import React from "react";
import { NavDropdown } from "react-bootstrap";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Trending1 from '../../assets/images/trending1.png'
import Trending2 from '../../assets/images/trending2.png'
import Trending3 from '../../assets/images/trending3.png'
import Trending4 from '../../assets/images/trending4.png'
import Profile from '../../assets/images/profile.png'
import Profile2 from '../../assets/images/profile2.png'
import Profile3 from '../../assets/images/profile3.png'
import Profile4 from '../../assets/images/profile4.png'
import Arrow from '../../assets/images/slider-arrow.svg'

function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >   
            <FontAwesomeIcon icon={faChevronRight} />
            {/* <img src={Arrow} className="icon next img-fluid" /> */}
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faChevronLeft} />
           {/* <img src={Arrow} className="icon prev img-fluid" /> */}
        </div>
    );
}
function Trending() {
    const trending = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: false,
        // adaptiveHeight: true,
        nextArrow: <SampleNextArrow className="icon next"/>,
        prevArrow: <SamplePrevArrow className="icon prev"/>,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false
                }
            }

        ]
    };
    return (
        <section className="trending-toppy main-padding section-margin">
            <div className="container-fluid p-0">
                <div className="heading text-left d-flex justify-content-between align-items-center ">
                    <div className="d-flex justify-content-start align-items-center">
                        <h2>Trending In </h2><NavDropdown title="All Categories">
                            <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action4">Another action</NavDropdown.Item>
                            <NavDropdown.Item href="#action5">Something else here</NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
                <Slider className="trending-slider" {...trending}>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Trending1} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <div className="profile-img">
                                    <img src={Profile} alt="" className="img-fluid" />
                                </div>
                                <h5>Dead Head</h5>
                                <p className="text-primary sub-heading">by DeadHeadVault</p>
                                <p>TIMECatsLoveEmHateEm is a bonus NFT for those who participated in our first TIMEPieces drop.</p>
                            </div>
                        </a>

                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Trending2} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <div className="profile-img">
                                    <img src={Profile2} alt="" className="img-fluid" />
                                </div>
                                <h5>Janathan Nash</h5>
                                <p className="text-primary sub-heading">by DeadHeadVault</p>
                                <p>The Krazy Koala collection is a collection of 9999 randomly generated koalas on the Ethereum Blockch…</p>
                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Trending3} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <div className="profile-img">
                                    <img src={Profile3} alt="" className="img-fluid" />
                                </div>
                                <h5>Fang Gang</h5>
                                <p className="text-primary sub-heading">by DeadHeadVault</p>
                                <p>Currently running a contest for all Common Bad Batch Holders. 24 randomly selected Co…</p>
                            </div>
                        </a>

                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Trending4} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <div className="profile-img">
                                    <img src={Profile4} alt="" className="img-fluid" />
                                </div>
                                <h5>Cyber Curated</h5>
                                <p className="text-primary sub-heading">by Oncyber</p>
                                <p>Kolectiv is an NFT marketplace that focuses on large drops with the best established and up and comi…</p>
                            </div>
                        </a>

                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Trending1} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <div className="profile-img">
                                    <img src={Profile} alt="" className="img-fluid" />
                                </div>
                                <h5>Dead Head</h5>
                                <p className="text-primary sub-heading">by DeadHeadVault</p>
                                <p>TIMECatsLoveEmHateEm is a bonus NFT for those who participated in our first TIMEPieces drop.</p>
                            </div>
                        </a>
                    </div>
                </Slider>
            </div>
        </section>

    )
}
export default Trending;